export default "__VITE_ASSET__BtMwt2bD__"